export const cashFlowProtectionFeatures = [
  {
    label: "Get guaranteed income and protection till the age of 100 years",
  },
  {
    label:
      "Get lump-sum benefit at the end of premium payment term through reversionary bonus",
  },
];

export const gcapFeatures = [
  {
    label: "Complete peace of mind as all benefits are guaranteed upfront",
  },
  {
    label:
      "Get additional benefits from 9th policy year through Guaranteed Accrual Additions",
  },
  {
    label:
      "Select from multiple options of policy term and premium paying term to suit everyones requirements",
  },
];

export const singlePayEndowmentFeatures = [
  {
    label: "Get guaranteed amount on maturity",
  },
  {
    label:
      "Get comprehensive life insurance cover ranging between 1.25 times to 10 times",
  },
  {
    label: "Make your cover more comprehensive through additional riders",
  },
];

export const foreverPensionFeatures = [
  { label: "Get guaranteed annuity throughout the life of the annuitant" },
  { label: "Option to customize with Immediate Annuity  or deferred Annuity" },
  { label: "Option of annuity  payable on a joint life basis" },
];

export const posSaralNiveshFeatures = [
  { label: "Guaranteed benefits on your investment" },
  {
    label: "Get bigger discounts on higher SA",
  },
  {
    label:
      "Pay premium for a shorter term and get covered for a longer term with limited pay",
  },
];

export const sjbFeatures = [
  { label: "Life insurance coverage available till age 70 years" },
  { label: "Flexibility to choose your own policy term from 5 to 40 years" },
  {
    label:
      "Option to choose from a wider premium payment frequency; Regular pay or Single pay or Limited pay",
  },
];

export const criticarePlusFeatures = [
  {
    label:
      "Cover against 17 critical illnesses such as Heart Attack, Third Degree Burns, Permanent Blindness, Severe Coma",
  },
  {
    label:
      "Waive off all future premium payments when you get diagnosed with a critical illness",
  },
];

export const wealthUltimaFeatures = [
  {
    label:
      "Mutiple invesment option to choose between Systematic Transfer Plan (STP) or Self Managed Strategy",
  },
  {
    label:
      "Loyalty Additions and Booster Additions will be added annualy after certain number of policy years",
  },
  {
    label:
      "Get Payout in the form of regular installments from 10th year with  Systematic Withdrawal Plan (SWP)",
  },
];

export const wealthPlusFeatures = [
  {
    label: "Get life cover to ensure financial protection",
  },
  {
    label:
      "Waiver off future premiums while the policy benefits remain intact in your absence with Rising Star Benefit",
  },
  {
    label:
      "Additional allocation every year from our side with Extra Allocation and Premium Booster",
  },
];

export const dhanLabhFeatures = [
  { label: "No surprises get guaranteed benefits" },
  { label: "Get additional benefits through “Assured Additions”" },
  {
    label:
      "Customize as per your need with various Policy Term  and Premium Paying Term",
  },
];

export const wealthPremierFeatures = [
  { label: "Single Premium payment and get life cover for 10 years" },
  { label: "Get Single & Joint Life Option" },
  { label: "Option of Partial Withdrawal" },
  {
    label:
      "Get additional allocation at the end of 6th, 8th and 10th policy year",
  },
];

export const aipFeatures = [
  { label: "Get both Protection and Income till 99 years" },
  { label: "Get Guaranteed Income from the end of your 2nd policy year" },
  {
    label:
      "Your family gets Income Benefit and Maturity Benefit with waiver of future premiums in your absence under FIB option",
  },
  {
    label:
      "Option to receive Income Benefit through 3 different Policy Terms and 4 different Premium Paying Terms",
  },
];

export const saralPensionFeatures = [
  {
    label: "Get guaranteed regular annuity income for life",
  },
  {
    label: "Get life Annuity with Return of Purchase price (ROP)",
  },
  {
    label:
      "Flexibility to receive annuity in monthly, quarterly, half yearly and yearly mode",
  },
];

export const posForeverPensionFeatures = [
  { label: "Guaranteed annuity throughout the life of the annuitant" },
  { label: "Option to customize with Immediate Annuity  or deferred Annuity" },
  { label: "Option of annuity  payable on a joint life basis" },
];

export const posSJBFeatures = [
  { label: "Life insurance coverage available till age 70 years" },
  { label: "Flexibility to choose your own policy term from 5 to 40 years" },
  {
    label:
      "Option to choose from a wider premium payment frequency; Regular pay or Single pay or Limited pay",
  },
];

export const pgiLumpsumFeatures = [
  {
    label:
      "Guaranteed lump sum even in uncertain times to secure your future financial needs",
  },
];

export const pgiShortTermIncomeFeatures = [
  {
    label:
      "Guaranteed income even in uncertain times to secure your future financial needs",
  },
];

export const pgiLongTermIncomeFeatures = [
  {
    label:
      "Guaranteed income even in uncertain times to secure your future financial needs",
  },
  {
    label: "Get Guaranteed lump sum at maturity",
  },
];

export const pgiRetirementFeatures = [
  {
    label:
      "Guaranteed income even in uncertain times to secure your future financial needs",
  },
  {
    label: "Get Guaranteed lump sum at maturity",
  },
  {
    label:
      "Mutiple income choices. Select between level income or increasing income",
  },
];

export const gisFeatures = [
  {
    label:
      "Secure your future goals with a plan which offers stable assured returns",
  },
  {
    label:
      "Flexibility to opt for the start of the income pay-out, 'Income Start Point' and the duration for which Income will be payable, 'Income Duration'",
  },
  {
    label:
      "Meet your changing financial needs with different plan options: 1.Flexible Income  2.Large Income",
  },
];

export const aisFeatures = [
  {
    label: "Guaranteed Income - Regular income and maturity benefit in this plan are guaranteed.",
  },
  {
    label: "Advantage Benefit - With Regular Income Advantage plan option, get a larger payout for 1st year survival benefit.",
  },
  {
    label: "Life Cover & 5 Riders - Life cover to secure your family and 5 optional riders to further enhance your plan’s protective element.",
  },
  {
    label: "Regular Income as Per Your Convenience - Choose the frequency of your income payouts as per your liking. You can choose to get monthly, quarterly, half-yearly, or annual income payouts."
  }
];

export const gssLumpsumIncomeFeatures = [
  {
    label:
      "Option to receive guaranteed returns as lumpsum at maturity or in a regular stream",
  },
  {
    label:
      "Receive the policy benefit, with all future premiums waived off in case of death or diagnosis with FIB option",
  },
  { label: "Enhanced cover option to protect your family in time of need" },
];

export const pgsFeatures = [
  {
    label: "Survival benefits in the form of Income Benefit Pay-outs",
  },
  {
    label: "Get guaranteed returns no matter what the circumstances are",
  },
  {
    label:
      "Get flexibility to choose from lumpsum benefit at maturity, policy term, premium paying frequency, income duration and income payout frequency",
  },
];

export const zindagiProtectLCO = [
  { label: "You can skip upto 8 premiums, while enjoying the plan benefits" },
  { label: "Added protection with child cover till he turns 25 years of age" },
  { label: " Life long protection with life cover till Age 100" },
  {
    label:
      "Double your family protection with Life Cover to Spouse on death of the life insured",
  },
];

export const easyPensionFeatures = [
  { label: "Protection + Pension in one plan" },
  { label: "Guaranteed¹ Loyalty Additions that enhance your returns" },
  { label: "Low premium allocation charges" },
  { label: "Get dual benefits of a regular income and a lump sum amount" },
]

export const posGISFeatures = [
  { label: "Secure your future goals with a plan which offers stable assured returns" },
  { label: "Flexibility to opt for the start of the income pay-out, Income Start Point’ and the duration for which Income will be payable, 'Income Duration'" },
  { label: "Meet your changing financial needs witth  Flexible Income Option" },
]

export const posGSSFeatures = [
  { label: "Option to receive guaranteed returns as lumpsum at maturity or in a regular stream" },
  { label: "Get a combination of guaranteed returns and Bonuses till the end of Policy term" },
]

export const fspFlexiIncomeFeatures = [
  { label: "Survival benefits in the form of Income Benefit Pay-outs" },
  { label: "Get a combination of guaranteed returns and Bonuses till the end of Policy term" },
  { label: "Get flexibility to choose from income payout start year, policy term, premium paying frequency" },
  { label: "Option to acrrue your survival benefits and the freedom to customise your plan." },
  { label: "Life Cover continuation Benefit" },
]

export const fspFlexiIncomeProFeatures = [
  { label: "Survival benefits in the form of Income Benefit Pay-outs comprising of Bonus and Guaranteed Lumpsum & Guaranteed Income" },
  { label: "Get a combination of guaranteed returns in the form of Lumpsumps every 5 years " },
  { label: "Get flexibility to choose from income payout start year, policy term, premium paying frequency" },
  { label: "Option to acrrue your survival benefits and the freedom to customise your plan." },
  { label: "Life Cover continuation Benefit" },
]

export const fspLargeSumFeatures = [
  { label: "Get Lumpsum at Maturity" },
  { label: "Life Cover continuation Benefit" },
]
export const bssFeatures = [
  { label: "Guaranteed income from as early as 1st year for up to 40 Years" },
  { label: "Premium Break Benefit for up to 2 times" },
  { label: " Accrue and/or Prepone income benefit pay-outs" }
];
export const activePensionPlusFeatures = [
  { label: "Get Guaranteed Regular Annuity for Life " },
  { label: "Opt for Annuity with return of Purchase Price " },
  { label: "Wide variety of Premium Paying Term and Deferment Period to cater to your needs " },
  { label: "Joint Life option " }
];
